import { useNavigate } from "react-router-dom";

export default function DashboardCard({ name, count, path }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/adminpanel/dashboard${path}`); // works fine
  };

  return (
    <div
      onClick={handleClick}
      className="w-90 h-48 p-8 rounded-lg shadow-md flex flex-col justify-center items-center 
                 transform transition-transform duration-300 hover:scale-105 hover:shadow-xl cursor-pointer"
      style={{ backgroundColor: "#e9d8fd" }}
    >
      <h2 className="text-2xl font-semibold mb-4 text-center">{name}</h2>
      <p className="text-3xl font-bold text-center">{count ?? 0}</p>
    </div>
  );
}
